{
  "version": 1,
  "asset_id": "7bb3e097-2df6-4928-aa34-2d90c5b50317",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/7bb3e097-2df6-4928-aa34-2d90c5b50317/gallery-7.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/7bb3e097-2df6-4928-aa34-2d90c5b50317/gallery-7.jpeg",
  "original_filename": "gallery-7.jpeg",
  "size": 1176027,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:37Z"
}
